import React from 'react'
import { NavLink } from 'react-router-dom'

export const CommonNav = () => {
    return (
        <app-sportsnav _ngcontent-rka-c46="" _nghost-rka-c44="">
            <div _ngcontent-rka-c44="" className="sport_tab">
                <ul _ngcontent-rka-c44="" className="nav nav-tabs">
                    {/* <li _ngcontent-rka-c44="" className="nav-item">
                        <NavLink _ngcontent-rka-c44="" to="/" routerlinkactive="active" className="nav-link">
                            <i _ngcontent-rka-c44="" className="fa-solid fa-home"></i> home </NavLink>
                    </li>
                    <li _ngcontent-rka-c44="" className="nav-item">
                        <NavLink _ngcontent-rka-c44="" to="/sports/inplay" routerlinkactive="active" className="nav-link">
                            <i _ngcontent-rka-c44="" className="fa-solid fa-play"></i> inplay </NavLink>
                    </li> */}
                    {/* <li _ngcontent-rka-c44="" className="nav-item">
                        <NavLink _ngcontent-rka-c44="" to="/sports/inplay" routerlink="/sports/inplay" routerlinkactive="active" className="nav-link">
                            <i _ngcontent-rka-c44="" className="fa-solid fa-play"></i> inplay </NavLink>
                    </li> */}
                    <li _ngcontent-rka-c44="" className="nav-item">
                        <NavLink _ngcontent-rka-c44="" to="/home" routerlinkactive="active" className="nav-link">
                            <i _ngcontent-rka-c44="" className="nav-icon fa-duotone fa-cricket-bat-ball"></i> Horse </NavLink>


                    </li>
                    {/* <li _ngcontent-rka-c44="" className="nav-item">
                        <NavLink _ngcontent-rka-c44="" to="/sports/soccer" routerlinkactive="active" className="nav-link">
                            <i _ngcontent-rka-c44="" className="nav-icon fa-duotone fa-football"></i> Football </NavLink>


                    </li>
                    <li _ngcontent-rka-c44="" className="nav-item">
                        <NavLink _ngcontent-rka-c44="" to="/sports/tennis" routerlinkactive="active" className="nav-link">
                            <i _ngcontent-rka-c44="" className="nav-icon fa-duotone fa-tennis-ball"></i> Tennis </NavLink>
                    </li>
                    <li _ngcontent-rka-c44="" className="nav-item">
                        <NavLink _ngcontent-rka-c44="" to="/sports/winner" routerlinkactive="active" className="nav-link">
                            <i _ngcontent-rka-c44="" className="nav-icon fa-duotone fa-trophy"></i> Winner </NavLink>
                    </li>
                    <li _ngcontent-rka-c44="" className="nav-item">

                        <NavLink _ngcontent-rka-c44="" to="/casino" routerlinkactive="active" className="nav-link">
                            <i _ngcontent-rka-c44="" className="nav-icon fa-duotone fa-coin"></i> Casino </NavLink>
                    </li>
                    <li _ngcontent-rka-c44="" className="nav-item">
                        <NavLink _ngcontent-rka-c44="" to="/sports/horse" routerlinkactive="active" className="nav-link">
                            <i _ngcontent-rka-c44="" className="nav-icon fa-duotone fa-horse"></i> Horse Racing </NavLink>


                    </li> */}
                    {/* <li _ngcontent-rka-c44="" className="nav-item">
                        <NavLink _ngcontent-rka-c44="" to="/sports/addfancy" routerlinkactive="active" className="nav-link">
                            <i _ngcontent-rka-c44="" className="nav-icon fa-duotone fa-cricket"></i> Add Fancy </NavLink>


                    </li> */}
                    {/* <li _ngcontent-rka-c44="" className="nav-item">


                    </li>
                    <li _ngcontent-rka-c44="" className="nav-item">


                    </li> */}


                </ul>
            </div>
        </app-sportsnav>
    )
}
